module.exports = require('./helpers/bundle-url').getBundleURL('iEWGC') + "logo-dark.eefe0b7f.svg";